/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/init-declarations */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
import type { BreadcrumbItem } from "@octopusdeploy/design-system-components";
import { Callout } from "@octopusdeploy/design-system-components";
import { logger } from "@octopusdeploy/logging";
import type { ActivityElement, ArtifactResource, GitRefResource, InterruptionResource, ISnapshotResource, KubernetesTaskResourceStatusResource, OctopusSpaceRepository, OctopusSystemRepository, ReleaseResource, ResourceCollection, RunbookResource, RunbookSnapshotResource, SpaceResource, TaskDetailsResource, TaskResource, } from "@octopusdeploy/octopus-server-client";
import { isReleaseResource, isRunbookSnapshotResource, Permission, ProjectContextRepository, Repository, TaskName, TaskState as TaskStateEnum, toGitBranchWhenUnknown } from "@octopusdeploy/octopus-server-client";
import type { LinkHref, TaskDateFilterType } from "@octopusdeploy/portal-routes";
import { links } from "@octopusdeploy/portal-routes";
import { Environment } from "@octopusdeploy/utilities";
import _, { compact, memoize } from "lodash";
import moment from "moment";
import * as React from "react";
import type { RouteComponentProps } from "react-router";
import { withRouter } from "react-router";
import type { AnalyticActionDispatcher } from "~/analytics/Analytics";
import { Action, useAnalyticActionDispatch } from "~/analytics/Analytics";
import { ContainersFeedbackCallout } from "~/areas/ContainersFeedbackCallout";
import { PublishSnapshotDialogLayout } from "~/areas/projects/components/Runbooks/PublishSnapshotDialogLayout/PublishSnapshotDialogLayout";
import { TaskStatusIcon } from "~/areas/projects/components/TaskStatusIcon/TaskStatusIcon";
import type { WithOptionalProjectContextInjectedProps } from "~/areas/projects/context/index";
import { useOptionalProjectContext } from "~/areas/projects/context/index";
import { AdHocScriptTaskSummary } from "~/areas/tasks/components/Task/AdHocScriptTaskSummary";
import BuildInformation from "~/areas/tasks/components/Task/BuildInformation/BuildInformation";
import Changes from "~/areas/tasks/components/Task/Changes/Changes";
import KubernetesDeploymentStatus from "~/areas/tasks/components/Task/K8sStatus/KubernetesDeploymentStatus";
import retrieveStepsWithKubernetesActions from "~/areas/tasks/components/Task/K8sStatus/retrieveStepsWithKubernetesActions";
import { TaskHistory } from "~/areas/tasks/components/Task/TaskHistory/TaskHistory";
import TaskLog from "~/areas/tasks/components/Task/TaskLog/TaskLog";
import { activityElementIdFromUniqueId, activityElementUniqueIdFromId, getSelectedLogLine, isVerbose, toggleVerbose } from "~/areas/tasks/components/Task/TaskLog/TaskLogUtil";
import { client, repository } from "~/clientInstance";
import { RunbookSnapshotPublishedChip } from "~/components/Chips";
import type { DataBaseComponentState, Refresh } from "~/components/DataBaseComponent/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent/DataBaseComponent";
import Dialog from "~/components/Dialog/Dialog";
import InternalLink from "~/components/Navigation/InternalLink";
import InternalRedirect from "~/components/Navigation/InternalRedirect/InternalRedirect";
import type { OverflowMenuNavLink } from "~/components/OverflowMenu/OverflowMenu";
import { OverflowMenuItems } from "~/components/OverflowMenu/OverflowMenu";
import type { PageAction, PrimaryPageAction } from "~/components/PageActions/PageActions";
import PaperLayout from "~/components/PaperLayout/PaperLayout";
import { isAllowed } from "~/components/PermissionCheck/PermissionCheck";
import type { UniqueActivityElement } from "~/components/TaskLogLines/TaskLogBlock";
import { UrlNavigationTabsContainer } from "~/primitiveComponents/navigation/Tabs";
import TabItem from "~/primitiveComponents/navigation/Tabs/TabItem";
import { timeOperationOptions } from "~/utils/OperationTimer/timeOperation";
import ModifyTaskStateDialog from "./ModifyTaskStateDialog";
import TaskSummary from "./TaskSummary/TaskSummary";
export enum BuiltInTask {
    Deploy = "Deploy",
    RunbookRun = "RunbookRun",
    ExportProjects = "ExportProjects",
    ImportProjects = "ImportProjects",
    BulkDeployment = "BulkDeployment"
}
interface TaskState extends DataBaseComponentState {
    task?: TaskResource<any>;
    taskSpace?: SpaceResource;
    taskScopedRepository?: OctopusSpaceRepository | OctopusSystemRepository;
    kubernetesOctopusStatus: KubernetesTaskResourceStatusResource;
    stepsWithKubernetesActions: string[];
    taskDetails?: TaskDetailsResource;
    artifacts?: ArtifactResource[];
    interruptions?: ResourceCollection<InterruptionResource>;
    activityElements?: UniqueActivityElement[];
    verbose: boolean;
    tail: boolean;
    reloads: number;
    cancelPending: boolean;
    moveToTopPending: boolean;
    redirectTo?: LinkHref;
    breadcrumbTitle?: string;
    breadcrumbPath?: LinkHref;
    breadcrumbOverflow?: OverflowMenuNavLink[];
    breadcrumbsItems?: BreadcrumbItem[];
    hasLoadedOnce?: boolean;
    snapshot: ISnapshotResource;
    changesMarkdown: string;
    runbook?: RunbookResource;
    taskDeploymentActionTypes: string[];
    stepsCorrelationIds?: {
        [key: string]: string;
    };
    gitRef?: GitRefResource;
    ranges: ActivityLogOptionsRange[];
    isFetchDisabled: boolean;
    initialTab: string;
}
interface ActivityLogOptionsRange {
    id: string;
    start: number;
    end: number;
}
interface TaskComponentProps {
    task?: TaskResource<any>;
    taskId: string;
    projectId?: string;
    tenantId?: string;
    environmentId?: string;
    getPrimaryPageAction?(Task: TaskResource<any>): PrimaryPageAction | undefined;
    getAdditionalPageActions?(Task: TaskResource<any>): PageAction[];
    additionalRefresh?(Task: TaskResource<any>): Promise<void>;
    delayRender(): boolean;
    statusSection?: React.ReactNode;
    defaultBreadcrumbItems?: BreadcrumbItem[];
    showBreadcrumbBackIcon?: boolean;
}
type TaskProps = TaskComponentProps & RouteComponentProps<any> & WithOptionalProjectContextInjectedProps;
type InternalTaskProps = TaskProps & {
    dispatchAction: AnalyticActionDispatcher;
};
const statesThatCanBeModified = [TaskStateEnum.Success, TaskStateEnum.Failed, TaskStateEnum.Canceled];
class InternalTask extends DataBaseComponent<InternalTaskProps, TaskState> {
    private timeLastRefreshTookInSeconds: number = 0;
    /**
     * Use memoization to remove unnecessary network calls as the UI is updated.
     * This allows us to regenerate the state by excluding or including machines,
     * and not call back to the server for deployment process info that will not
     * have changed.
     */
    repositoryDeploymentProcessesGet = memoize((release: ReleaseResource) => this.props.projectContext!.state.projectContextRepository.DeploymentProcesses.getForRelease(release));
    repositoryRunbookProcessGet = memoize((id: string, taskSpaceScopedRepository: OctopusSpaceRepository) => taskSpaceScopedRepository.RunbookProcess.get(id));
    constructor(props: InternalTaskProps) {
        super(props);
        this.state = {
            reloads: 0,
            verbose: isVerbose(this.props),
            tail: true,
            cancelPending: false,
            moveToTopPending: false,
            snapshot: null!,
            changesMarkdown: null!,
            taskDeploymentActionTypes: [],
            kubernetesOctopusStatus: { KubernetesStepsStatus: [] },
            stepsWithKubernetesActions: [],
            stepsCorrelationIds: undefined,
            ranges: this.getSelectedRanges(),
            isFetchDisabled: false,
            initialTab: "taskSummary",
        };
    }
    getSelectedRanges(): ActivityLogOptionsRange[] {
        const selection = getSelectedLogLine(this.props);
        if (selection) {
            return [
                {
                    start: selection.line < 50 ? 0 : selection.line - 50,
                    end: selection.line + 50,
                    id: activityElementIdFromUniqueId(selection.elementUniqueId),
                },
            ];
        }
        return [];
    }
    async componentDidMount() {
        await this.doBusyTask(async () => {
            const task = this.props.task ? this.props.task : await repository.Tasks.get(this.props.taskId, { spaces: ["all"] });
            const taskScopedRepository = task.SpaceId ? await repository.forSpace(task.SpaceId) : repository.forSystem();
            const taskSpace = task.SpaceId ? await repository.Spaces.get(task.SpaceId) : undefined;
            this.setState({
                task,
                taskSpace,
                taskScopedRepository,
            }, () => this.doBusyTask(async () => {
                this.doRefresh = await this.startRefreshLoop(() => this.refresh(this.state.verbose, this.state.ranges), this.getRefreshInterval, false, timeOperationOptions.forRefresh());
            }));
        }, { timeOperationOptions: timeOperationOptions.forInitialLoad() });
    }
    isDeploymentTask = () => this.state.task?.Name === BuiltInTask.Deploy && this.state.task.Arguments.DeploymentId === this.props.match.params.deploymentId;
    async refresh(verbose: boolean, ranges: ActivityLogOptionsRange[]) {
        const startTime = moment();
        const { task, taskScopedRepository } = this.state;
        if (task === undefined || taskScopedRepository === undefined) {
            throw new Error("Refreshing task failed as the initial data for the task was not loaded, this should never happen.");
        }
        this.setState({ verbose, ranges, reloads: this.state.reloads + 1, isFetchDisabled: true });
        const rangeStrings = ranges.map((r) => [r.id, r.start, r.end].join(":"));
        const taskDetailArgs = { verbose, tail: 50, ranges: rangeStrings.join("|") };
        const taskDetailsPromise = taskScopedRepository.Tasks.details(task, taskDetailArgs);
        const interruptionsPromise = this.isTaskSpaceScopedRepository(taskScopedRepository) &&
            isAllowed({
                permission: Permission.InterruptionViewSubmitResponsible,
                project: this.props.projectId,
                environment: this.props.environmentId,
                tenant: this.props.tenantId,
            }, this.state.task?.SpaceId ? { spaceId: this.state.task.SpaceId } : "system")
            ? taskScopedRepository.Interruptions.list({ regarding: this.props.taskId })
            : Promise.resolve([] as any as ResourceCollection<InterruptionResource>);
        const taskDetails = await taskDetailsPromise;
        const activityElements = taskDetails.ActivityLogs.map((e: ActivityElement, n: number) => this.setIdPrefix(e, n));
        // Only supply breadcrumbs if this is a deployment task (as it will be redirected to the project area where it needs a breadcrumb).
        let snapshot: ReleaseResource | RunbookSnapshotResource | undefined;
        let breadcrumbTitle: string | undefined;
        let breadcrumbPath: LinkHref | undefined;
        let breadcrumbOverflow: OverflowMenuNavLink[] | undefined;
        let breadcrumbsItems: BreadcrumbItem[] | undefined;
        let kubernetesStatusUpdatePromise: Promise<KubernetesTaskResourceStatusResource> = Promise.resolve({ KubernetesStepsStatus: [] });
        let stepsWithKubernetesActions: string[] = [];
        const isDeploymentTask = this.isDeploymentTask();
        let changesMarkdown = null;
        // No point retrieving kubernetes status updates more than once for a completed task
        if (this.state.taskDetails?.Task.IsCompleted) {
            kubernetesStatusUpdatePromise = Promise.resolve(this.state.kubernetesOctopusStatus);
        }
        else {
            kubernetesStatusUpdatePromise = this.state.task!.SpaceId ? taskScopedRepository.Tasks.retrieveKubernetesStatusUpdate(this.state.task!) : Promise.resolve({ KubernetesStepsStatus: [] });
        }
        if (isDeploymentTask && this.isTaskSpaceScopedRepository(taskScopedRepository)) {
            const deployment = await taskScopedRepository.Deployments.getDeploymentSummaryForTask(this.props.match.params.deploymentId);
            changesMarkdown = deployment.ChangesMarkdown;
            snapshot = deployment ? await taskScopedRepository.Releases.get(deployment.ReleaseId) : null!;
            if (isReleaseResource(snapshot)) {
                const project = deployment ? await taskScopedRepository.Projects.get(deployment.ProjectId) : null;
                if (project) {
                    try {
                        if (taskDetails.Task.IsCompleted) {
                            let gitRef: GitRefResource | undefined;
                            const snapshotGitRef = toGitBranchWhenUnknown(snapshot.VersionControlReference?.GitRef);
                            if (project.IsVersionControlled === true && !!snapshotGitRef) {
                                gitRef = await taskScopedRepository.Projects.getGitRef(project, snapshotGitRef);
                                this.setState({ gitRef: gitRef });
                            }
                            const projectContextRepository = new ProjectContextRepository(client, project, gitRef);
                            const deploymentProcess = await projectContextRepository.DeploymentProcesses.get();
                            // Filter step correlation ids by those present in the deployment process
                            const correlationIds: {
                                [key: string]: string;
                            } = {};
                            deployment.ExecutionPlanLogContext.Steps.forEach((context) => {
                                if (deploymentProcess.Steps.some((step) => step.Slug === context.Slug)) {
                                    correlationIds[context.CorrelationId] = context.Slug;
                                }
                            });
                            if (correlationIds) {
                                this.setState({ stepsCorrelationIds: correlationIds });
                            }
                        }
                    }
                    catch (e) {
                        logger.warn("Failed to get deployment process for project", e);
                    }
                }
                breadcrumbTitle = snapshot ? `Release ${snapshot.Version}` : null!;
                breadcrumbPath = snapshot ? links.releasePage.generateUrl({ spaceId: project!.SpaceId, projectSlug: project!.Slug, releaseVersion: snapshot.Version }) : null!;
                breadcrumbsItems = [
                    { label: "Releases", pageUrl: links.releasesPage.generateUrl({ spaceId: project!.SpaceId, projectSlug: project!.Slug }) },
                    { label: snapshot.Version, pageUrl: breadcrumbPath },
                ];
                const process = await this.repositoryDeploymentProcessesGet(snapshot);
                stepsWithKubernetesActions = retrieveStepsWithKubernetesActions(process.Steps);
            }
            const actionTypesBffResponse = await taskScopedRepository.Deployments.getDeploymentProcessActionTypes(deployment.DeploymentProcessId);
            this.setState({ taskDeploymentActionTypes: actionTypesBffResponse.ActionTypes });
        }
        const isRunbookTask = !!(taskDetails.Task.Name === BuiltInTask.RunbookRun && taskDetails.Task.Arguments.RunbookRunId === this.props.match.params.runbookRunId && this.isTaskSpaceScopedRepository(taskScopedRepository));
        let runbook: RunbookResource | undefined;
        if (isRunbookTask) {
            const runbookRun = await taskScopedRepository.RunbookRuns.get(this.props.match.params.runbookRunId);
            runbook = await taskScopedRepository.Runbooks.get(runbookRun.RunbookId);
            snapshot = runbookRun ? await taskScopedRepository.RunbookSnapshots.get(runbookRun.RunbookSnapshotId) : null!;
            if (isRunbookSnapshotResource(snapshot)) {
                const process = await this.repositoryRunbookProcessGet(snapshot.FrozenRunbookProcessId, taskScopedRepository);
                stepsWithKubernetesActions = retrieveStepsWithKubernetesActions(process.Steps);
                const project = runbookRun ? await taskScopedRepository.Projects.get(runbookRun.ProjectId) : null;
                breadcrumbTitle = runbook ? `${runbook.Name}` : null!;
                breadcrumbPath = snapshot ? links.projectRunbookRunsListPage.generateUrl({ spaceId: runbook.SpaceId, projectSlug: project!.Slug, runbookId: runbook.Id }) : null!;
                breadcrumbsItems = [
                    { label: "Runbooks", pageUrl: links.projectRunbooksPage.generateUrl({ spaceId: project!.SpaceId, projectSlug: project!.Slug }) },
                    { label: breadcrumbTitle, pageUrl: breadcrumbPath },
                ];
                breadcrumbOverflow = [
                    OverflowMenuItems.navItem("Overview", links.projectRunbookOverviewPage.generateUrl({ spaceId: runbook.SpaceId, runbookId: runbook.Id, projectSlug: project!.Slug })),
                    OverflowMenuItems.navItem("Runs", links.projectRunbookRunsListPage.generateUrl({ spaceId: runbook.SpaceId, runbookId: runbook.Id, projectSlug: project!.Slug })),
                    OverflowMenuItems.navItem("Process", links.projectRunbookProcessListPage.generateUrl({ spaceId: runbook.SpaceId, runbookId: runbook.Id, projectSlug: project!.Slug, processId: runbook.RunbookProcessId })),
                    OverflowMenuItems.navItem("Settings", links.projectRunbookSettingsPage.generateUrl({ spaceId: runbook.SpaceId, projectSlug: project!.Slug, runbookId: runbook.Id })),
                ];
            }
        }
        const artifacts = this.loadArtifactsPromise();
        const result = {
            taskDetails,
            activityElements,
            artifacts: await artifacts,
            interruptions: await interruptionsPromise,
            task: taskDetails.Task,
            breadcrumbTitle: breadcrumbTitle!,
            breadcrumbPath: breadcrumbPath!,
            breadcrumbOverflow,
            breadcrumbsItems,
            hasLoadedOnce: true,
            snapshot: snapshot!,
            changesMarkdown: changesMarkdown!,
            runbook: runbook!,
            kubernetesOctopusStatus: await kubernetesStatusUpdatePromise,
            stepsWithKubernetesActions,
        };
        if (this.props.additionalRefresh) {
            await this.props.additionalRefresh(taskDetails.Task);
        }
        this.timeLastRefreshTookInSeconds = moment().diff(startTime, "seconds");
        if (task.State == TaskStateEnum.Executing) {
            // Switch to task log when the task starts. But don't switch back
            this.setState({ initialTab: "taskLog" });
        }
        this.setState({ isFetchDisabled: false });
        return result;
    }
    getRefreshInterval = (hidden: boolean) => {
        if (!this.state.task) {
            return 2000;
        }
        if (this.timeLastRefreshTookInSeconds >= 5) {
            // Refresh time is terrible, back right off
            return hidden ? 120000 : 20000;
        }
        const refreshIsFast = this.timeLastRefreshTookInSeconds < 2;
        const completedRecently = this.state.task.CompletedTime && moment().diff(moment(this.state.task.CompletedTime), "seconds") < 15;
        if (completedRecently && refreshIsFast) {
            // Make sure we get the final logs that get written after the task officially completes
            return hidden ? 10000 : 2000;
        }
        if (this.state.task.IsCompleted) {
            // Keep refreshing after completion in case auto-deploy kicks in or someone else changes that task state
            return hidden ? 60000 : 20000;
        }
        const isQueuedOrStartedRecently = !this.state.task.StartTime || moment().diff(moment(this.state.task.StartTime), "seconds") < 15;
        if (isQueuedOrStartedRecently && refreshIsFast) {
            // Refresh often so the user can see it start and see it finish quickly if it's a short deployment
            return hidden ? 5000 : 1000;
        }
        return hidden ? 30000 : 5000;
    };
    // This is a bit hacky since auto-deploys that kick off from same deployment will have the same task prefix
    setIdPrefix(element: ActivityElement, n: number): UniqueActivityElement {
        return {
            ...element,
            uniqueId: activityElementUniqueIdFromId(element.Id, n),
            Children: element.Children ? element.Children.map((c) => this.setIdPrefix(c, n)) : null!,
        };
    }
    setVerbose = (value: boolean) => {
        toggleVerbose(this.props, value);
        this.setState({ verbose: value }, async () => this.doRefresh());
    };
    recurseCountLogs(elements?: ActivityElement[]): number {
        if (!elements) {
            return 0;
        }
        return _.sum(elements.map((a) => a.LogElements.length + this.recurseCountLogs(a.Children)));
    }
    fetchRange = (element: ActivityElement, start: number, end: number) => {
        let ranges = this.state.ranges.slice();
        ranges.push({
            start: start,
            end: end,
            id: element.Id,
        });
        // Around 10,000 logs and the UX starts to freeze up
        // So above that, keep only the most recently selected range
        // But allow them to have at least 2 ranges open even if that pushes us past 10K (so they can compare logs)
        if (this.recurseCountLogs(this.state.taskDetails?.ActivityLogs) > 10000 && ranges.length > 2) {
            ranges = [ranges[ranges.length - 1]];
        }
        this.setState({ ranges }, async () => this.doRefresh());
    };
    isAlreadyPublished = () => {
        const runbook = this.state.runbook;
        const snapshot = this.state.snapshot;
        if (!runbook || !snapshot) {
            return false;
        }
        return runbook.PublishedRunbookSnapshotId === snapshot.Id;
    };
    getPublishRunbookSnapshotPageAction = (): PageAction | null => {
        const task = this.state.task;
        const taskScopedRepository = this.state.taskScopedRepository;
        if (!task || !task.IsCompleted || !this.isTaskSpaceScopedRepository(taskScopedRepository)) {
            return null;
        }
        const runbook = this.state.runbook;
        const snapshot = this.state.snapshot;
        if (!runbook || !snapshot) {
            return null;
        }
        const hasRunbookEditPermissions = isAllowed({ permission: Permission.RunbookEdit, project: this.props.projectId, wildcard: true }, this.state.task?.SpaceId ? { spaceId: this.state.task.SpaceId } : "system");
        if (!hasRunbookEditPermissions) {
            return null;
        }
        if (this.isAlreadyPublished()) {
            return null;
        }
        return {
            type: "dialog",
            label: "Publish",
            extraContext: "Publishing makes the runbook available to consumers and triggers.",
            renderDialog: ({ closeDialog, isOpen }) => (<Dialog open={isOpen} onRequestClose={closeDialog}>
                    <PublishSnapshotDialogLayout close={closeDialog} onPublishSnapshotDialogClicked={async () => {
                    await this.doBusyTask(async () => {
                        runbook.PublishedRunbookSnapshotId = snapshot.Id;
                        await taskScopedRepository.Runbooks.modify(runbook);
                        const path = links.projectRunbookSnapshotInfoPage.generateUrl({ spaceId: runbook!.SpaceId, projectSlug: runbook!.ProjectId, runbookId: runbook!.Id, runbookSnapshotId: snapshot.Id });
                        this.setState({ redirectTo: path });
                    });
                }}/>
                </Dialog>),
            buttonType: "secondary",
        };
    };
    renderEditStateButton = () => {
        const task = this.state.task;
        if (!task!.IsCompleted || statesThatCanBeModified.indexOf(task!.State) === -1) {
            return null;
        }
        return OverflowMenuItems.dialogItem("Edit state", <ModifyTaskStateDialog availableStates={statesThatCanBeModified} currentTaskState={task!.State} onStateChanged={this.changeTaskState}/>, {
            permission: Permission.TaskEdit,
            project: this.props.projectId,
            environment: this.props.environmentId,
            tenant: "*",
            spaceScope: task?.SpaceId ? { spaceId: task.SpaceId } : "system",
        });
    };
    renderTryAgainButton = () => {
        const task = this.state.task!;
        if (!task.IsCompleted) {
            return null;
        }
        if (task.Name === TaskName.AdHocScript) {
            if (task.Arguments.ActionTemplateId) {
                const path = links.runStepTemplatePage.generateUrl({ spaceId: task.SpaceId!, templateId: task.Arguments.ActionTemplateId }, { retry: task.Id });
                return OverflowMenuItems.navItem("Modify and re-run", path);
            }
            else {
                return OverflowMenuItems.navItem("Modify and re-run", links.scriptConsolePage.generateUrl({ retry: task.Id }));
            }
        }
        else if (task.Name === TaskName.BulkDeployment) {
            return OverflowMenuItems.item(task.FinishedSuccessfully ? "Re-run" : "Try again", this.rerun, {
                permission: Permission.DeploymentCreate,
                project: "*",
                environment: "*",
                tenant: "*",
                spaceScope: task?.SpaceId ? { spaceId: task.SpaceId } : "system",
            });
        }
        else if (task.CanRerun) {
            return OverflowMenuItems.item(task.FinishedSuccessfully ? "Re-run" : "Try again", this.rerun, {
                permission: Permission.TaskCreate,
                project: this.props.projectId,
                environment: this.props.environmentId,
                tenant: "*",
                spaceScope: task?.SpaceId ? { spaceId: task.SpaceId } : "system",
            });
        }
        else {
            return this.renderRedeployButton();
        }
    };
    renderRedeployButton = () => {
        const isRelease = isReleaseResource(this.state.snapshot);
        const deployToLabel = isRelease ? "Re-deploy..." : "Re-run...";
        const executePermission = isRelease ? Permission.DeploymentCreate : Permission.RunbookRunCreate;
        const routePath = isRelease
            ? links.createDeploymentPage.generateUrl({ spaceId: this.state.snapshot.SpaceId, projectSlug: this.state.snapshot.ProjectId, releaseVersion: this.state.snapshot.Id }, { previousDeploymentId: this.state.taskDetails!.Task.Arguments.DeploymentId })
            : links.createRunbookRunForSnapshotPage.generateUrl({ spaceId: this.state.snapshot.SpaceId, projectSlug: this.state.snapshot.ProjectId, runbookId: this.state.runbook!.Id, runbookSnapshotId: this.state.snapshot.Id }, { previousRunbookRunId: this.state.taskDetails!.Task.Arguments.RunbookRunId });
        return OverflowMenuItems.navItem(deployToLabel, routePath, { permission: executePermission, project: this.state.snapshot.ProjectId, wildcard: true, spaceScope: this.state.task?.SpaceId ? { spaceId: this.state.task.SpaceId } : "system" });
    };
    renderDeployToButton = () => {
        const canRenderDeployTo = this.state.snapshot && this.state.taskDetails && !this.state.taskDetails.Task.HasPendingInterruptions && this.state.taskDetails.Task.State !== TaskStateEnum.Executing;
        if (!canRenderDeployTo) {
            return null;
        }
        const isRelease = isReleaseResource(this.state.snapshot);
        const deployToLabel = isRelease ? "Deploy to..." : "Run on...";
        const executePermission = isRelease ? Permission.DeploymentCreate : Permission.RunbookRunCreate;
        const routePath = isRelease
            ? links.createDeploymentPage.generateUrl({ spaceId: this.state.snapshot.SpaceId, projectSlug: this.state.snapshot.ProjectId, releaseVersion: this.state.snapshot.Id })
            : links.createRunbookRunForSnapshotPage.generateUrl({ spaceId: this.state.snapshot.SpaceId, projectSlug: this.state.snapshot.ProjectId, runbookId: this.state.runbook!.Id, runbookSnapshotId: this.state.snapshot.Id });
        return OverflowMenuItems.navItem(deployToLabel, routePath, { permission: executePermission, project: this.state.snapshot.ProjectId, wildcard: true, spaceScope: this.state.task?.SpaceId ? { spaceId: this.state.task.SpaceId } : "system" });
    };
    renderDeleteExecutionButton = () => {
        const canRenderDeleteDeploymentButton = !!(this.state.snapshot && this.state.taskDetails && this.state.taskDetails.Task.Name === BuiltInTask.Deploy && this.state.taskDetails.Task.Arguments.DeploymentId);
        const canRenderDeleteRunbookRunButton = !!(this.state.snapshot && this.state.taskDetails && this.state.taskDetails.Task.Name === BuiltInTask.RunbookRun && this.state.taskDetails.Task.Arguments.RunbookRunId);
        if (!canRenderDeleteDeploymentButton && !canRenderDeleteRunbookRunButton) {
            return null;
        }
        const isRelease = isReleaseResource(this.state.snapshot);
        const deletePermission = isRelease ? { permission: Permission.DeploymentDelete } : { permission: Permission.RunbookEdit, project: this.props.projectId, wildcard: true, spaceId: this.state.task?.SpaceId };
        return OverflowMenuItems.deleteItem(`Delete ${isRelease ? "deployment" : "run"}...`, `Are you sure you want to delete this ${isRelease ? "deployment" : "run"}?`, this.handleDeleteConfirm, <div>
                <p>Deleting this {isRelease ? "deployment" : "run"} is permanent. There is no going back.</p>
                <p>Do you wish to continue?</p>
            </div>, deletePermission);
    };
    renderViewPreviousDeploymentsButton = () => {
        const task = this.state.task;
        const projectContext = this.props.projectContext;
        if (!projectContext || !task || !task.SpaceId) {
            return null;
        }
        if (!this.isDeploymentTask()) {
            return null;
        }
        let dateFilterParams: {
            dateFilterType?: TaskDateFilterType;
            fromDate?: Date;
            toDate?: Date;
        } = {};
        if (task.StartTime) {
            dateFilterParams = this.createDateFilterParams(task.StartTime, "Start Time");
        }
        else if (task.QueueTime) {
            dateFilterParams = this.createDateFilterParams(task.QueueTime, "Queue Time");
        }
        return OverflowMenuItems.navItem("View previous deployments", links.projectTasksPage.generateUrl({ spaceId: task.SpaceId, projectSlug: projectContext.state.model.Slug }, { ...dateFilterParams, spaces: [task.SpaceId], environment: this.props.environmentId, name: BuiltInTask.Deploy, tenant: this.props.tenantId }));
    };
    createDateFilterParams = (taskInitialTime: string, type: TaskDateFilterType) => {
        const toDate = new Date(taskInitialTime);
        toDate.setSeconds(toDate.getSeconds() - 1); // Don't include the current task in the filtered tasks list
        const fromDate = new Date(toDate);
        fromDate.setMonth(toDate.getMonth() - 6);
        return { dateFilterType: type, fromDate, toDate };
    };
    handleDeleteConfirm = async () => {
        if (!this.isTaskSpaceScopedRepository(this.state.taskScopedRepository)) {
            return true;
        }
        if (isReleaseResource(this.state.snapshot)) {
            const deployment = await this.state.taskScopedRepository.Deployments.get(this.state.taskDetails!.Task.Arguments.DeploymentId);
            await this.state.taskScopedRepository.Deployments.del(deployment);
            this.setState({ redirectTo: links.releaseRedirect.generateUrl({ spaceId: this.state.snapshot.SpaceId, releaseId: this.state.snapshot.Id }) });
        }
        else if (isRunbookSnapshotResource(this.state.snapshot)) {
            const runbookRun = await this.state.taskScopedRepository.RunbookRuns.get(this.state.taskDetails!.Task.Arguments.RunbookRunId);
            await this.state.taskScopedRepository.RunbookRuns.del(runbookRun);
            this.setState({
                redirectTo: links.projectRunbookSnapshotInfoPage.generateUrl({ spaceId: this.state.snapshot.SpaceId, projectSlug: this.state.snapshot.ProjectId, runbookId: this.state.snapshot.RunbookId, runbookSnapshotId: this.state.snapshot.Id }),
            });
        }
        return true;
    };
    changeTaskState = async (newTaskState: string, reason: string) => {
        await this.doBusyTask(async () => {
            this.setState({ task: await this.state.taskScopedRepository!.Tasks.changeState(this.state.task!, newTaskState, reason) });
        });
    };
    rerun = async () => {
        await this.doBusyTask(async () => {
            const newTask = await this.state.taskScopedRepository!.Tasks.rerun(this.state.task!);
            this.setState({ redirectTo: links.taskPage.generateUrl({ taskId: newTask.Id }) });
        });
    };
    performMoveToTop = async () => {
        await this.doBusyTask(async () => {
            try {
                this.props.dispatchAction("Move Task to Top of Queue", { resource: "Task", action: Action.Update });
                this.setState({ moveToTopPending: true });
                await this.state.taskScopedRepository!.Tasks.prioritize(this.state.task!.Id);
                await this.doRefresh();
            }
            finally {
                this.setState({ moveToTopPending: false });
            }
        });
    };
    getMoveToTopPageAction = (): null | PageAction => {
        const task = this.state.task!;
        if (task.State !== TaskStateEnum.Queued) {
            return null;
        }
        return {
            type: "button",
            buttonType: "secondary",
            label: "Move to top",
            disabled: this.state.moveToTopPending,
            busyLabel: "Updating...",
            onClick: this.performMoveToTop,
            hasPermissions: isAllowed({ permission: Permission.TaskEdit, project: this.props.projectId, environment: this.props.environmentId, tenant: "*" }, task?.SpaceId ? { spaceId: task.SpaceId } : "system"),
        };
    };
    performCancel = async () => {
        await this.doBusyTask(async () => {
            try {
                this.props.dispatchAction("Cancel task", { resource: "Task", action: Action.Cancel });
                this.setState({ cancelPending: true });
                await this.state.taskScopedRepository!.Tasks.cancel(this.state.task!.Id);
                await this.doRefresh();
            }
            finally {
                this.setState({ cancelPending: false });
            }
        });
    };
    getCancelPageAction = (): null | PageAction => {
        const task = this.state.task!;
        if (task.IsCompleted) {
            return null;
        }
        const isCancelling = this.state.cancelPending || task.State === TaskStateEnum.Cancelling;
        return {
            type: "button",
            buttonType: "destructive",
            label: "Cancel",
            disabled: isCancelling,
            busyLabel: "Cancelling...",
            onClick: this.performCancel,
            hasPermissions: isAllowed({ permission: Permission.TaskCancel, project: this.props.projectId, environment: this.props.environmentId, tenant: "*" }, task?.SpaceId ? { spaceId: task.SpaceId } : "system"),
        };
    };
    renderDevTools() {
        if (Environment.isInDevelopmentMode()) {
            return (<div style={{
                    background: "lightyellow",
                    padding: "10px 20px",
                    color: "black",
                    position: "fixed",
                    bottom: "20px",
                    right: "20px",
                    height: "auto",
                    width: "auto",
                    fontSize: "12px",
                    zIndex: 10000,
                    border: "1px solid black",
                }}>
                    {this.state.taskDetails && <div>Actual log is {(this.state.taskDetails?.PhysicalLogSize / 1024 / 1024).toLocaleString()} MB on disk</div>}
                    <div>Fetched {this.recurseCountLogs(this.state.taskDetails?.ActivityLogs)} logs from server</div>
                    <div>Reloads {this.state.reloads}</div>
                    <div>Last refresh took (s): {this.timeLastRefreshTookInSeconds}</div>
                    <div>
                        Ranges:{" "}
                        {this.state.ranges.map((r, n) => (<span key={n}>
                                {r.start}:{r.end}&nbsp;
                            </span>))}
                    </div>
                </div>);
        }
    }
    render() {
        const redirectTo = this.state.redirectTo;
        if (redirectTo) {
            return <InternalRedirect to={redirectTo} push={false}/>;
        }
        const selectedElement = getSelectedLogLine(this.props)?.elementUniqueId;
        const details = this.state.taskDetails;
        const task = this.state.task!;
        const canRender = task && details && !this.props.delayRender();
        const overflowMenuItems = this.getOverflowMenu(canRender!);
        let pageActions: PageAction[] = [];
        if (canRender) {
            const additionalActions = this.props.getAdditionalPageActions ? this.props.getAdditionalPageActions(task) : [];
            const publishSnapshotButton = this.getPublishRunbookSnapshotPageAction();
            if (publishSnapshotButton) {
                additionalActions.push(publishSnapshotButton);
            }
            pageActions = [this.getMoveToTopPageAction(), this.getCancelPageAction(), ...additionalActions].filter((x): x is PageAction => !!x);
        }
        const interruptionsCount = canRender && !task.IsCompleted && this.state.interruptions && this.state.interruptions.Items ? this.state.interruptions.Items.filter((i) => i.IsPending).length : 0;
        const summaryWarning = interruptionsCount > 0 ? `This task has interruption${interruptionsCount > 1 ? "s" : ""} preventing it from continuing` : null;
        return (<PaperLayout title={task ? task.Description : "Task"} titleLogo={task ? <TaskStatusIcon item={task!}/> : undefined} titleChip={this.isAlreadyPublished() ? <RunbookSnapshotPublishedChip noMargin={true}/> : undefined} breadcrumbTitle={this.state.breadcrumbTitle} breadcrumbPath={this.state.breadcrumbPath} breadcrumbOverflow={this.state.breadcrumbOverflow} breadcrumbsItems={this.state.breadcrumbsItems ?? this.props.defaultBreadcrumbItems} showBreadcrumbBackIcon={this.props.showBreadcrumbBackIcon} busy={this.state.busy} enableLessIntrusiveLoadingIndicator={false} errors={this.errors} primaryAction={canRender ? this.props.getPrimaryPageAction?.(task) : undefined} pageActions={pageActions} overflowActions={overflowMenuItems} fullWidth={true} statusSection={this.props.statusSection}>
                {canRender && (<>
                        {this.state.taskSpace && this.state.taskSpace.Id != client.spaceId && (<Callout hideTitle={true} type={"information"}>
                                You are viewing a task from Space: <strong>{this.state.taskSpace.Name}</strong>. <InternalLink to={links.spaceRootRedirect.generateUrl({ spaceId: this.state.taskSpace.Id })}>Change to this Space.</InternalLink>
                            </Callout>)}
                        <ContainersFeedbackCallout onTaskPage={true} actionTypes={this.state.taskDeploymentActionTypes}></ContainersFeedbackCallout>
                        {this.renderDevTools()}
                        <UrlNavigationTabsContainer defaultValue={this.state.initialTab}>
                            <TabItem label="Task Summary" value="taskSummary" warning={summaryWarning!}>
                                <TaskSummary task={task} projectId={this.props.projectId} environmentId={this.props.environmentId} tenantId={this.props.tenantId} artifacts={this.state.artifacts} interruptions={this.state.interruptions} activityElements={this.state.activityElements} stepsCorrelationIds={this.state.stepsCorrelationIds} taskDetails={this.state.taskDetails} doRefresh={this.doRefresh} snapshot={this.state.snapshot} gitRef={this.state.gitRef}/>
                            </TabItem>
                            <TabItem label="Task Log" value="taskLog">
                                <TaskLog details={details!} verbose={this.state.verbose} activityElements={this.state.activityElements!} stepsCorrelationIds={this.state.stepsCorrelationIds} tail={this.state.tail} initialExpandedId={selectedElement} onFetchRange={(element, start, end) => this.fetchRange(element, start, end)} setVerbose={this.setVerbose} isFetchDisabled={this.state.isFetchDisabled} gitRef={this.state.gitRef}/>
                            </TabItem>
                            <TabItem label="History" value="history" onActive={() => this.props.dispatchAction("View History", { action: Action.View, resource: "Task" })}>
                                {task ? <TaskHistory task={task} projectId={this.props.projectId} environmentId={this.props.environmentId} tenantId={this.props.tenantId}/> : null}
                            </TabItem>
                            {this.state.changesMarkdown === null ? null : (<TabItem label="Changes" value="changes" onActive={() => this.props.dispatchAction("View Changes", { action: Action.View, resource: "Task" })}>
                                    <Changes changesMarkdown={this.state.changesMarkdown}/>
                                </TabItem>)}
                            {this.state.stepsWithKubernetesActions.length > 0 && (<TabItem label="Kubernetes Object Status" value="kubernetesDeploymentStatus">
                                    <KubernetesDeploymentStatus status={this.state.kubernetesOctopusStatus} activityLogs={this.state.taskDetails?.ActivityLogs || []} stepsWithKubernetesActions={this.state.stepsWithKubernetesActions} projectId={this.props.projectId}/>
                                </TabItem>)}
                            {task!.Name === TaskName.AdHocScript && (<TabItem label={task!.Arguments.ActionTemplateId ? "Template Parameters" : "Script body"} value="adHocScriptSummary">
                                    <AdHocScriptTaskSummary task={task!}/>
                                </TabItem>)}
                            {this.isDeploymentTask() ? (<TabItem label="Build Information" value="buildInformation" onActive={() => this.props.dispatchAction("View Build Information", { action: Action.View, resource: "Task" })}>
                                    {this.isTaskSpaceScopedRepository(this.state.taskScopedRepository) ? (<BuildInformation deploymentId={this.props.match.params.deploymentId} doBusyTask={this.doBusyTask} taskScopedRepository={this.state.taskScopedRepository}/>) : null}
                                </TabItem>) : null}
                        </UrlNavigationTabsContainer>
                    </>)}
            </PaperLayout>);
    }
    private doRefresh: Refresh = () => Promise.resolve();
    private getOverflowMenu = (canRender: boolean) => {
        return canRender ? compact([this.renderEditStateButton(), this.renderTryAgainButton(), this.renderDeployToButton(), this.renderDeleteExecutionButton(), this.renderViewPreviousDeploymentsButton()]) : [];
    };
    private loadArtifactsPromise = () => {
        return this.isTaskSpaceScopedRepository(this.state.taskScopedRepository) &&
            isAllowed({
                permission: Permission.ArtifactView,
                project: this.props.projectId,
                environment: this.props.environmentId,
                tenant: this.props.tenantId,
            }, this.state.task?.SpaceId ? { spaceId: this.state.task.SpaceId } : "system")
            ? this.state.taskScopedRepository.Artifacts.list({
                regarding: this.props.taskId,
                take: Repository.takeAll,
                order: "asc",
            }).then((r) => r.Items)
            : Promise.resolve([] as ArtifactResource[]);
    };
    private isTaskSpaceScopedRepository = (repository: OctopusSpaceRepository | OctopusSystemRepository | undefined): repository is OctopusSpaceRepository => {
        return repository !== undefined && "Projects" in repository;
    };
    static displayName = "InternalTask";
}
function Task(props: TaskComponentProps & RouteComponentProps) {
    const projectContext = useOptionalProjectContext();
    const dispatchAction = useAnalyticActionDispatch();
    return <InternalTask {...props} projectContext={projectContext} dispatchAction={dispatchAction}/>;
}
export default withRouter(Task);
